import { createContext, useContext } from 'react';

interface DualNavContextType {
  widthState: 'collapsed' | 'expanded';
}

const DualNavContext = createContext<DualNavContextType>({
  widthState: 'expanded',
});

const useDualNavContext = () => {
  return useContext(DualNavContext);
};

export { DualNavContext, useDualNavContext };
